import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/Layout";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Checkbox } from "@/components/ui/checkbox";
import { Progress } from "@/components/ui/progress";

const CHECKLIST = [
  "Purchase agreement fully executed",
  "Earnest money deposited",
  "Title search ordered",
  "Preliminary title report reviewed",
  "Loan payoff / reinstatement verified",
  "Property inspection completed",
  "Repair scope confirmed",
  "Insurance quote obtained",
  "Seller disclosures received",
  "Authorization to release info signed",
  "HOA estoppel requested",
  "Closing date scheduled with escrow",
  "Final walkthrough completed",
  "Settlement statement approved",
];

export default function DueDiligence() {
  const [leads, setLeads] = useState([]);
  const [leadId, setLeadId] = useState("");
  const [dd, setDd] = useState({});
  useEffect(() => { api.get("/leads").then((r) => setLeads(r.data)); }, []);

  const onSelect = (id) => { setLeadId(id); const l = leads.find((x) => x.id === id); setDd(l?.due_diligence || {}); };
  const toggle = async (item) => {
    const next = { ...dd, [item]: !dd[item] };
    setDd(next);
    await api.put(`/leads/${leadId}`, { due_diligence: next });
  };
  const done = CHECKLIST.filter((c) => dd[c]).length;
  const pct = Math.round((done / CHECKLIST.length) * 100);

  return (
    <div>
      <PageHeader title="Due Diligence" subtitle="Contract-to-closing checklist" />
      <div className="p-4 sm:p-6 lg:p-8 max-w-3xl">
        <div className="bg-card border border-border rounded-md p-5 mb-6">
          <div className="text-xs uppercase tracking-[0.15em] text-muted-foreground font-medium mb-2">Select Lead</div>
          <Select value={leadId} onValueChange={onSelect}>
            <SelectTrigger data-testid="dd-lead-select"><SelectValue placeholder="Choose a lead under contract" /></SelectTrigger>
            <SelectContent>{leads.map((l) => <SelectItem key={l.id} value={l.id}>{l.lead_id_display} · {l.property?.property_address} · {l.status}</SelectItem>)}</SelectContent>
          </Select>
        </div>

        {leadId ? (
          <div className="bg-card border border-border rounded-md p-6" data-testid="dd-checklist">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-display font-bold">Closing Checklist</h3>
              <span className="font-mono-nums text-sm text-muted-foreground">{done}/{CHECKLIST.length} · {pct}%</span>
            </div>
            <Progress value={pct} className="mb-6" />
            <div className="space-y-1">
              {CHECKLIST.map((item) => (
                <label key={item} className="flex items-center gap-3 px-3 py-2.5 rounded-md hover:bg-secondary cursor-pointer transition-colors" data-testid={`dd-item-${CHECKLIST.indexOf(item)}`}>
                  <Checkbox checked={!!dd[item]} onCheckedChange={() => toggle(item)} />
                  <span className={`text-sm ${dd[item] ? "line-through text-muted-foreground" : ""}`}>{item}</span>
                </label>
              ))}
            </div>
          </div>
        ) : <div className="text-muted-foreground">Select a lead to view its checklist.</div>}
      </div>
    </div>
  );
}
